










































import { Component, Vue } from 'vue-property-decorator';
import firebase from "firebase";

@Component
export default class AppLayout extends Vue {
  private user: any = null;
  private menuVisible = false;
  
  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.user = user;
      } else {
        this.$router.push('/')
      }
    });
  }
  
  logout() {
    firebase.auth().signOut().then(() => {
      firebase.auth().onAuthStateChanged(() => {
        this.$router.push('/')
      })
    })
  }
}
